/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { CustomDomainOrganizationMapping } from '../../data/interfaces';
import {
    CustomDomainOrganizationActions,
    FETCH_CUSTOM_DOMAIN_ORGANIZATION_FAILURE,
    FETCH_CUSTOM_DOMAIN_ORGANIZATION_REQUEST,
    FETCH_CUSTOM_DOMAIN_ORGANIZATION_SUCCESS,
} from '../types/customDomainOrganization';

interface CustomDomainOrganizationState {
    customDomainOrganizationMapping: CustomDomainOrganizationMapping;
    error: string;
    loading: boolean;
    success: boolean;
}

const initialState: CustomDomainOrganizationState = {
    customDomainOrganizationMapping: { domain_name : '', organization: { handle: '' } },
    error: '',
    loading: false,
    success: false,
};

const customDomainsOrganizationReducer = (
    state = initialState,
    action: CustomDomainOrganizationActions
) => {
    switch (action.type) {
        case FETCH_CUSTOM_DOMAIN_ORGANIZATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                success: false,
            };
        case FETCH_CUSTOM_DOMAIN_ORGANIZATION_SUCCESS: {
            const organizationMapping = action.payload;
            return {
                ...state,
                loading: false,
                customDomainOrganizationMapping: organizationMapping,
                error: '',
                success: true,
            };
        }
        case FETCH_CUSTOM_DOMAIN_ORGANIZATION_FAILURE:
            return {
                ...state,
                loading: false,
                customDomainOrganizationMapping: { domain_name : '', organization: { handle: '' } },
                error: action.payload,
                success: false,
            };
        default:
            return state;
    }
};

export default customDomainsOrganizationReducer;
